import { tapResponse } from '@ngrx/operators';
import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
  withProps,
} from '@ngrx/signals';
import {
  entityConfig,
  setAllEntities,
  withEntities,
} from '@ngrx/signals/entities';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap } from 'rxjs';
import { Injector } from '@angular/core';
import { IrisService } from '@shared/services/iris.service';

// Specialty entity config
const specialtyEntity = () =>
  entityConfig({
    collection: '_specialties',
    entity: type<string>(),
    selectId: (entity: string) => entity,
  });

/**
 * withSpecialtiesEntities is a function that creates a signal store feature
 * for managing the specialty entity slice. It provides an ability to plug and play
 * It uses the NgRx Signals library to create a reactive store feature.
 */
export const withSpecialtiesEntities = (_injector: Injector) => {
  return signalStoreFeature(
    withProps((store) => ({
      store,
    })),
    withEntities(specialtyEntity()),
    withMethods(({ store }) => {
      const _fetchSpecialties = rxMethod<void>(
        pipe(
          switchMap(() => {
            const irisService = _injector.get(IrisService);
            return irisService.getSpecialtyList().pipe(
              tapResponse({
                error: (error: Error) =>
                  console.error('Error loading specialties:', error),
                finalize: () => patchState(store, { loading: false }),
                next: (response: string[]) => {
                  patchState(
                    store,
                    setAllEntities(response, specialtyEntity()),
                  );
                },
              }),
            );
          }),
        ),
      );
      return {
        setSpecialties: () => _fetchSpecialties(),
      };
    }),
  );
};
